export default "<object type=\"image/svg+xml\" data=\"assets/icons/loader-64px-outline_circle-03.svg\" class=\"preloder\"></object>"